<template>
  <router-link tag="a" :to="{ name: 'users.overview', params: { 'id': user.id }}">
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-4">
        <div class="row">
          <div class="col-auto">
            <div class="user-avatar">
              <div class="avatar">
                <img v-bind:src="getAvatar(user.id)" alt="Lindsey Fleming" data-toggle="tooltip" title="" :data-original-title="user.name">
              </div>
            </div>
          </div>
          <div class="col d-flex align-items-center">
            <p class="strong text-truncate">{{ user.name }}</p>
          </div>
        </div><!-- /.row -->
      </div>
      <div class="col-8 col-lg-5 col-xl-6">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Email Address:</span>
          {{ user.email }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>

import {user} from 'mixins'

export default {
  mixins: [user],
  props: {
    user: {
      required: true,
      type: Object
    }
  }
}
</script>
